const $inject = ['$scope', '$routeParams', '$filter', 'booleanRestrictionService', 'dataService'];

const lbaBooleanRestrictionSelectCtrl = function ($scope, $routeParams, $filter, booleanRestrictionService, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.display = $filter(vm.settings.booleanRestrictionFilter || 'booleanRestrictionDisplay');
  vm.booleanRestrictions = booleanRestrictionService.get();

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });
};

lbaBooleanRestrictionSelectCtrl.$inject = $inject;

export default lbaBooleanRestrictionSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaBooleanRestrictionSelect/lbaBooleanRestrictionSelectCtrl.js